import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDatepickerI18n,
  NgbModule,
} from '@ng-bootstrap/ng-bootstrap';
import { provideNgxMask } from 'ngx-mask';
import {
  CustomAdapter,
  CustomDateParserFormatter,
  CustomDatepickerI18nService,
} from '../../../../services/datepicker';
import { AutocompleteDropdownComponent, ButtonComponent } from '../../atoms';
import { CalendarEndDateModule } from '../calendar-enddate/calendar-enddate.module';
import { CalendarModule } from '../calendar/calendar.module';
import { InputAutocompleteModule } from '../input-autocomplete/input-autocomplete.module';
import { InputClassModule } from '../input-class/input-class.module';
import { InputPassengersModule } from '../input-passengers/input-passengers.module';
import { InputRangeModule } from '../input-range/input-range.module';
import { MultivueloModule } from '../multivuelo/multivuelo.module';
import { NewCalendarModule } from '../new-calendar/new-calendar.module';
import { PopUpPasajerVuelosoModule } from '../pop-up-pasajero-vuelos/pop-up-pasajero-vuelos.module';
import { PopUpPasajeroModule } from '../pop-up-pasajero/pop-up-pasajero.module';
import { TabActividadesComponent } from './tab-actividades/tab-actividades.component';
import { TabArmaPaquetesComponent } from './tab-arma-paquetes/tab-arma-paquetes.component';
import { TabAutosComponent } from './tab-autos/tab-autos.component';
import { TabHotelComponent } from './tab-hotel/tab-hotel.component';
import { TabPaquetesComponent } from './tab-paquetes/tab-paquetes.component';
import { TabVueloHotelComponent } from './tab-vuelo-hotel/tab-vuelo-hotel.component';
import { TabVuelosMulticityComponent } from './tab-vuelos-multicity/tab-vuelos-multicity.component';

@NgModule({
  declarations: [
    TabVueloHotelComponent,
    TabHotelComponent,
    TabActividadesComponent,
    TabArmaPaquetesComponent,
    TabPaquetesComponent,
    TabAutosComponent,
    TabVuelosMulticityComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PopUpPasajeroModule,
    CalendarModule,
    CalendarEndDateModule,
    InputAutocompleteModule,
    PopUpPasajerVuelosoModule,
    NgbModule,
    InputRangeModule,
    ButtonComponent,
    InputClassModule,
    NewCalendarModule,
    InputPassengersModule,
    MultivueloModule,
    AutocompleteDropdownComponent,
  ],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18nService },
    provideNgxMask(),
  ],
  exports: [
    TabVueloHotelComponent,
    TabHotelComponent,
    TabActividadesComponent,
    TabArmaPaquetesComponent,
    TabPaquetesComponent,
    TabAutosComponent,
    TabVuelosMulticityComponent,
  ],
})
export class FilterTabsModule {}
